import React, { Component } from 'react';

import PendingActionsIcon from '@mui/icons-material/PendingActions';

// summary widget component
import SummaryWidget from 'components/SummaryWidget';

// services
import {fetchPendingHatcheryChangesCount} from 'services/hatcheries';


export default class TotalChangeRequestHatcheries extends Component {

  state = { count : '...' }
  
  async componentDidMount () {
    try {
      let response = await fetchPendingHatcheryChangesCount({});
      this.setState({count : response.data})
    } catch (error) {
      console.log(error);
    }
  }
  
  render() {
    return (
      <SummaryWidget 
        label = {'Total Change Requests Pending'} 
        count = {this.state.count} 
        icon = {<PendingActionsIcon />}
        url = { '/aqf/hatcheries/approvals/hatcherychanges' }
      />
    );
  }
}